<div class="number-stats" [ngClass]="cardClass" [style.height]="data?.height || null">
  <div class="card stat-card" [ngClass]="cardClass">
    <div class="card-content">
      <div class="stat-header">
        <div class="card-title" [innerHTML]="formattedTitle"></div>
        <div class="stat-icon" *ngIf="iconName" [ngClass]="data?.icon?.tone || data?.iconTone || ''">
          <mat-icon>{{ iconName }}</mat-icon>
        </div>
      </div>

      <div *ngIf="subtitle" class="card-subtitle">{{ subtitle }}</div>

      <div class="card-value-or-error">
        <ng-container *ngIf="!hasError; else errorTpl">
          <div class="value-row">
            <span class="card-value">{{ stat }}</span>
          </div>
        </ng-container>
        <ng-template #errorTpl>
          <mat-icon class="stat-error-icon">error_outline</mat-icon>
        </ng-template>
      </div>

      <div *ngIf="note" class="card-note">{{ note }}</div>

      <div *ngIf="badges.length" class="badge-strip">
        <div class="stat-badge" *ngFor="let badge of badges">
          <span class="badge-label">{{ badge.label }}</span>
          <span class="badge-value">{{ badge.value }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
